import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCliqzComponent } from './simple-icons-cliqz.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCliqzComponent ],
    exports:      [ SimpleIconsCliqzComponent ],
    bootstrap:    []
})
export class SimpleIconsCliqzModule {}
